var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.autocompleteValue,
        expression: "autocompleteValue"
      }
    ],
    ref: "autocomplete",
    class: _vm.className,
    attrs: { type: "text", id: _vm.id, placeholder: _vm.placeholder },
    domProps: { value: _vm.autocompleteValue },
    on: {
      blur: function($event) {
        _vm.onBlur()
      },
      change: _vm.onChange,
      focus: function($event) {
        _vm.onFocus()
      },
      keypress: _vm.onKeyPress,
      keyup: _vm.onKeyUp,
      input: function($event) {
        if ($event.target.composing) {
          return
        }
        _vm.autocompleteValue = $event.target.value
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c2d7f39a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2d7f39a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/VueGoogleAutocomplete.vue
// module id = wzbb
// module chunks = 1